import { createApp } from 'vue';
import loading from './index.vue';

const app = createApp(loading);
const instance = app.mount(document.createElement('div'));
document.body.appendChild(instance.$el);

const ld = {
  show() {
    instance.show();
  },

  hide() {
    instance.hide();
  },

  isShow: instance.showLoadingModal,
};

export default ld;
